import { isAfter, parseISO } from 'date-fns'

export type AppMetaJson = {
  version: string
  buildDate: string
}

export function isRemoteBuildNewerThanBundle(
  remoteBuildDate: string,
  bundleBuildDate: string
): boolean {
  const remote = parseISO(remoteBuildDate)
  const bundle = parseISO(bundleBuildDate)
  return isAfter(remote, bundle)
}

function isAppMetaJson(value: unknown): value is AppMetaJson {
  if (value === null || typeof value !== 'object') {
    return false
  }
  const o = value as Record<string, unknown>
  return (
    typeof o.version === 'string' &&
    typeof o.buildDate === 'string' &&
    o.version.length > 0 &&
    o.buildDate.length > 0
  )
}

export async function fetchAppMetaJson(): Promise<AppMetaJson | null> {
  try {
    const response = await fetch('/meta.json', { cache: 'no-store' })
    if (!response.ok) {
      return null
    }
    const data: unknown = await response.json()
    return isAppMetaJson(data) ? data : null
  } catch {
    return null
  }
}
